import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Container, Grid, Typography} from '@mui/material';
import productImg from '../../../media/background_images/sapore-tercer-producto.png'
import {ProductsCategoryFeature} from "./ProductsCategoryFeature";
import {observer} from "mobx-react";
import useFeature from "../../../useFeature";
import {ID_PRODUCT_DETAIL_PATH} from "../../../routes";

const ProductsCategoryScreen = () => {
    const feature = useFeature(() => new ProductsCategoryFeature())

    const isFeatureReady = () => {
        return feature && feature.loaded;
    }
    return (isFeatureReady() &&
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} className="hidden-xs">
                    <div className="text-center margintop60">
                        <Typography variant="h3">{feature.categoryName}</Typography>
                    </div>
                </Grid>
                <Grid item xs={12} className="visible-xs">
                    <div className="text-center margintop30">
                        <Typography variant="h3">{feature.categoryName}</Typography>
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                {feature.articles.filter(article => !article.EsDemo).map(item => (
                    <Grid item xs={12} sm={6} md={4} key={item.Id}>
                        <div className="product-item relative">
                            <Link to={ID_PRODUCT_DETAIL_PATH} className="img-box">
                                <img
                                    src={productImg}
                                    className="img-responsive img-producto-categoria" alt="Foto de Categoría"/>
                            </Link>
                            <div className="footer-product">
                                <Link to={ID_PRODUCT_DETAIL_PATH} className="h5 title-product show">
                                    <Typography variant="h5">{item.Producto.Nombre}</Typography>
                                </Link>
                                <Button variant="outlined" color="primary" component={Link}
                                        to={ID_PRODUCT_DETAIL_PATH}>
                                    Ver Producto
                                </Button>
                            </div>
                        </div>
                    </Grid>
                ))}
            </Grid>
            <hr className="divider-line footer-line"/>
        </Container>
    );
};

export default observer(ProductsCategoryScreen);
